import { render, staticRenderFns } from "./VendorsPersonsFilesTab.vue?vue&type=template&id=10a97e62&scoped=true&"
import script from "./VendorsPersonsFilesTab.vue?vue&type=script&lang=js&"
export * from "./VendorsPersonsFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./VendorsPersonsFilesTab.vue?vue&type=style&index=0&id=10a97e62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a97e62",
  null
  
)

export default component.exports